function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.167,
    height: 15.522,
    viewBox: "0 0 18.167 15.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.27 10.42A2.3 2.3 0 0 0 19.379 9h2.892a.849.849 0 0 0 0-1.7h-2.892a2.269 2.269 0 0 0-4.219 0H5.747a.848.848 0 0 0 0 1.7h9.413a2.3 2.3 0 0 0 2.11 1.42zm0-1.2a1.085 1.085 0 1 1 1.081-1.081 1.075 1.075 0 0 1-1.081 1.086zM5.721 12.784a.845.845 0 0 0 0 1.688h2.988a2.276 2.276 0 0 0 4.228 0h9.308a.844.844 0 0 0 0-1.687h-9.309a2.281 2.281 0 0 0-4.228 0zm5.106 1.934a1.084 1.084 0 0 1-1.09-1.09 1.085 1.085 0 1 1 1.09 1.09zm6.442 6.671a2.276 2.276 0 0 0 2.109-1.433h2.892a.845.845 0 0 0 0-1.687h-2.891a2.269 2.269 0 0 0-4.219 0H5.747a.844.844 0 0 0 0 1.688h9.413a2.276 2.276 0 0 0 2.11 1.432zm0-1.2a1.075 1.075 0 0 1-1.081-1.081 1.081 1.081 0 1 1 1.081 1.081z",
    transform: "translate(-4.912 -5.867)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.cb3a9f2e.svg";
export { ForwardRef as ReactComponent };